export default __webpack_public_path__ + "static/media/_ic_papper_act.01e65e65.svg";